export const APP_VERSION = "1.12.1"; // Version.Sprint.BugFix
